import { Component, OnInit } from '@angular/core';
import {TipoDispositivo} from '../../../models/tipo-dispositivos.model';
import {CatalogosService} from '../../../services/catalogos.service';
@Component({
  selector: 'app-lista-dispositivos',
  templateUrl: './lista-dispositivos.component.html',
  styleUrls: ['./lista-dispositivos.component.css']
})
export class ListaDispositivosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Dispositivos Médicos',
      routerLink: '/dispositivos'
    }
  ];

  tipos: TipoDispositivo[];
  loading = false;

  constructor(private catalogosService: CatalogosService) { }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposDispositivos().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }

}
